import React, { useEffect, useState } from "react";
import PitcherData from "./PitcherData";
import BatterData from "./BatterData";

export default function MlbPositionalData() {
  const [tab, setTab] = useState("pitchers");
  const [theme, setTheme] = useState("dark");
  const isDark = theme === "dark";

  // ✅ this is the missing piece: drive Tailwind dark mode globally
  useEffect(() => {
    const root = document.documentElement; // <html>
    if (isDark) root.classList.add("dark");
    else root.classList.remove("dark");
  }, [isDark]);

  // ✅ use Tailwind's dark: variants (same style as your working projections wrapper)
  const outerClass =
    "min-h-screen bg-slate-100 text-slate-900 " +
    "dark:bg-slate-950 dark:text-slate-100";

  const pillWrap =
    "inline-flex items-center gap-1 rounded-xl p-1 border " +
    "bg-white border-slate-200 shadow-inner " +
    "dark:bg-slate-900/80 dark:border-slate-700";

  const pillBtn = (active) =>
    "px-3 py-1.5 rounded-lg text-sm transition " +
    (active
      ? "bg-sky-500 text-slate-950 shadow font-semibold"
      : "text-slate-700 hover:text-slate-900 hover:bg-slate-100 " +
        "dark:text-slate-200 dark:hover:text-white dark:hover:bg-slate-800/60");

  const themeWrap =
    "inline-flex items-center rounded-full px-1 py-1 text-[11px] ring-1 " +
    "bg-white ring-slate-300 dark:bg-slate-900/90 dark:ring-slate-700/80";

  const themeBtn = (active) =>
    "px-3 py-1 rounded-full font-medium transition " +
    (active
      ? "bg-sky-500 text-slate-950 shadow-sm"
      : "text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100");

  return (
    <div className={outerClass}>
      <div className="mx-auto w-full max-w-screen-2xl px-3 sm:px-4 md:px-6 py-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-4">
          <div className="flex items-baseline gap-3 flex-wrap">
            <h1 className="text-2xl md:text-3xl font-extrabold mb-0.5">
              MLB — Positional Data
            </h1>

            <div className={pillWrap}>
              <button
                type="button"
                className={pillBtn(tab === "pitchers")}
                onClick={() => setTab("pitchers")}
              >
                Pitchers
              </button>
              <button
                type="button"
                className={pillBtn(tab === "batters")}
                onClick={() => setTab("batters")}
              >
                Batters
              </button>
            </div>
          </div>

          <div className={themeWrap}>
            <button type="button" onClick={() => setTheme("dark")} className={themeBtn(isDark)}>
              Dark
            </button>
            <button type="button" onClick={() => setTheme("light")} className={themeBtn(!isDark)}>
              Light
            </button>
          </div>
        </div>

        {/* ✅ IMPORTANT: don't pass theme/embedded unless the components support it.
            The global dark class will handle the styling. */}
        {tab === "pitchers" ? <PitcherData /> : <BatterData />}
      </div>
    </div>
  );
}
